<template>
  <v-container fluid class="pa-12" style="max-width: 1344px;"> </v-container>
</template>
<script>
export default {
  name: 'Dashboard'
}
</script>
